import { render, staticRenderFns } from "./comunidades.vue?vue&type=template&id=399a637e"
import script from "./comunidades.vue?vue&type=script&lang=js"
export * from "./comunidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports